export type PieceType = "pawn" | "rook" | "knight" | "bishop" | "queen" | "king";
export type PieceColor = "white" | "black";

export interface Piece {
  type: PieceType;
  color: PieceColor;
}

export type Board = (Piece | null)[][];

export interface ChessGame {
  board: Board;
  turn: PieceColor;
  winner: PieceColor | null;
  isDraw: boolean;
  selected: { r: number; c: number } | null;
  validMoves: { r: number; c: number }[];
  inCheck: boolean;
  lastMove: { from: { r: number; c: number }; to: { r: number; c: number } } | null;
  moveCount: number;
  halfMoveClock: number;
}

export const SIZE = 8;
export const EMPTY = null;

export const PIECE_EMOJIS: Record<string, string> = {
  "white-king": "♔", "white-queen": "♕", "white-rook": "♖", "white-bishop": "♗", "white-knight": "♘", "white-pawn": "♙",
  "black-king": "♚", "black-queen": "♛", "black-rook": "♜", "black-bishop": "♝", "black-knight": "♞", "black-pawn": "♟",
};

export const PIECE_VALUES: Record<PieceType, number> = {
  pawn: 100, knight: 320, bishop: 330, rook: 500, queen: 900, king: 20000,
};
